import React, { useState, useEffect } from 'react'
import {Container} from './style'

import { Button, Input, Select, Modal, Table, Popconfirm, Col, Form, message, Icon } from 'antd'

import DeTable from '../../../component/DeTable'
import moment from 'moment'

import CarInfoHttp from '../../../request/car-request'
import CommonHttp from '../../../request/common-request'


const Option = Select.Option;
const _request = new CarInfoHttp()
const _commonrequest = new CommonHttp()

function CarInfo(props) {
    const [tableTotal, setTableTotal] = useState(0)
    const [modalType, setModalType] = useState('') //新增or编辑
    const [editVisible, setEditVisible] = useState(false) //编辑项
    const [confirmLoading, setConfirmLoading] = useState(false) //编辑模态框加载图标
    const [carNo, setCarNo] = useState('')
    const [driver, setDriver] = useState('')
    const [washSpotList, setWashSpotList] = useState([])

    const tableColunm =
        [
            {
                title: '序号',
                key: 'number',
                render: (text, record, index) => (
                    <span>{index + 1}</span>
                )
            },
            {
                title: '车牌号',
                dataIndex: 'carNo',
                key: 'carNo',
            },
            {
                title: '车辆类型',
                key: 'carType',
                dataIndex: 'carType',
                render: (text, record, index) => (
                	carTypeData.map((item,index1) => {
						if(record.carType === item.dictValue) {
							return  <span>{item.dictDesc}</span>
						}
					})

                )
            },
            {
                title: '驾驶人',
                dataIndex: 'driver',
                key: 'driver',
            },
//          {
//              title: '所属猪场',
//              key: 'pigFramName',
//              dataIndex: 'pigFramName',
//          },
            {
                title: '手机号',
                key: 'phone',
                dataIndex: 'phone',
            },
            {
                title: '操作日期',
                dataIndex: 'createDate',
                key: 'createDate',
				render: (text, record, index) => {
					return <span>{moment(record.createDate).format('YYYY-MM-DD HH:mm:ss')}</span>;
				}
            },
            {
                title: '操作',
                key: 'action',
                render: (text, record, index) => (
                    <span>
                        <span style={{ marginRight: 8 }} className='tableA' onClick={openModal.bind(this, 'edit', record)}>编辑</span>
                        <Popconfirm title="确认删除？" okText="删除" okType="danger" cancelText="取消" onConfirm={deleteRow.bind(this, record.id)}>
                            <span className='tableADelete'>删除</span>
                        </Popconfirm>
                    </span>
                ),
            },
        ]
     //表格结构
    const [tableData, setTableData] = useState([]) //表格数据
    const [carTypeData, setCarTypeData] = useState([]) //车辆类型列表
    const [childRegionData, setChildRegionData] = useState([]) //猪场列表
    const [pageNo, setPageNo] = useState(1)
    const [pageSize, setPageSize] = useState(10)
    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 8 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 14 },
        },
    }
    const { getFieldDecorator } = props.form
    useEffect(() => {
        getCarInfoList()
        getDictList()
        getChildRegionList()
    }, [])
    //获取列表
    const getCarInfoList = (ButtonType, pageNo = 1, pageSize = 10) => {
        let params = {
            carNo:carNo,
            driver:driver,
            pageNo,
            pageSize
        }
        if (ButtonType === 'reset') {
            params = {}
        }
        _request.getCarInfoList(params).then(res => {
            setTableTotal(res.total || 0)
            setTableData(res.list)
        })
    }
    //获取车辆类型列表
    const getDictList = () => {
        let params = {
           dictType:'CAR_TYPE'
        }
        _commonrequest.getDictList(params).then(res => {
            setCarTypeData(res.list)
        })
    }

    //获取猪场列表
    const getChildRegionList = () => {
        let params = {}
        _commonrequest.getChildRegionList(params).then(res => {
            setChildRegionData(res)
        })
    }



    //删除最外的表格行
    const deleteRow = (id) => {
        let params = {
            id
        }
        _request.deleteCarInfo(params).then(res => {
            message.info('删除成功！')
            getCarInfoList()
        })
    }
    //打开编辑页
    const openModal = (type, record) => {
        const { setFieldsValue } = props.form
        setModalType(type)
        setEditVisible(true)
        if(type !== 'add'){
        	//获取关联的猪场列表
            let params = {
            	carId:record.id
            }
	        _request.getCarFramList(params).then(res => {
                let arr = res.map(item => item);
                setFieldsValue({
                    // pigFramId:res.map(item => Number(item)),//.map(Number)
                    pigFramId:arr,//.map(Number)
                })
                selectPigFram(arr);
	        })
	        _request.getCarWashSpotList(params).then(res => {
                setFieldsValue({
                    washSpotIds:res.map(item => item),//.map(Number)
                })
	        })

            setTimeout(() => {
                setFieldsValue({
                    carNo: record.carNo,
                    carType: record.carType,
                    driver: record.driver,
                    phone: record.phone,
                    //pigFramId: Number(record.pigFramId),
                    id: record.id
                })
            }, 0)
        }

    }

    //编辑页提交
    const editConfire = () => {
        const { getFieldValue, validateFields } = props.form
        validateFields((err, value) => {
            if (!err) {
                setConfirmLoading(true)
                //let regionName = childRegionData.filter(item => item.regionId === getFieldValue('pigFramId'))[0].regionName
                //let newData = getFieldValue('pigFramId').map(item => item.toString()).join('-')
                if (modalType === 'add') {
                    let params = {
                        carNo: getFieldValue('carNo'),
                        carType: getFieldValue('carType'),
                        driver: getFieldValue('driver'),
                        phone: getFieldValue('phone'),
                        pigFramIds: JSON.stringify(getFieldValue('pigFramId')),
                        washSpotIds: JSON.stringify(getFieldValue('washSpotIds'))
                        //pigFramId: newData
                        //pigFramName: regionName
                    }
                    _request.addCarInfo(params).then(res => {
                        setConfirmLoading(false)
                        message.info('新增成功！')
                        setEditVisible(false)
                        getCarInfoList()
                    })
                } else {
                    let params = {
                        carNo: getFieldValue('carNo'),
                        carType: getFieldValue('carType'),
                        driver: getFieldValue('driver'),
                        phone: getFieldValue('phone'),
                        pigFramIds: JSON.stringify(getFieldValue('pigFramId')),
                        washSpotIds: JSON.stringify(getFieldValue('washSpotIds')),
                        //pigFramId: newData,
                        //pigFramName: regionName,
                        id: getFieldValue('id')
                    }
                    _request.updateCarInfo(params).then(res => {
                        setConfirmLoading(false)
                        message.info('修改成功！')
                        setEditVisible(false)
                        getCarInfoList()
                    })
                }
            }
        })
    }

    const selectPigFram = (e) =>{
        const { setFieldsValue } = props.form
        if (e.length > 0){
            const regionIds = e.join(',');
            _request.getWashSetListByFarmId({ regionIds }).then(res =>{
                setWashSpotList(res)
            });
        }else {
            setWashSpotList([])
            setFieldsValue({
                washSpotIds: []
            })
        }
    }

    //编辑页取消
    const cancelEdit = () => {
        setEditVisible(false)
        setModalType('')
        setConfirmLoading(false)
    }

    //搜索
    const clickSearch = () => {
        setPageNo(1)
        setPageSize(10)
        getCarInfoList()
    }
    //重置
    const clickReset = () => {
		setDriver('')
		setCarNo('')
        setPageNo(1)
        setPageSize(10)
        getCarInfoList('reset')
    }

    const onPaginationChange = (pageNo, pageSize) =>{
        setPageSize(pageSize);
        setPageNo(pageNo);
        //查询
        getCarInfoList('',pageNo,pageSize);
    }

    return (
        <Container>
            <div className="top">
                <Button type="primary" style={{ marginRight: 10,backgroundColor: '#689F38',borderColor: '#689F38' }} onClick={openModal.bind(this, 'add')}><span className='iconfont icon-tianjia buttonIcon'></span>新增</Button>
                <Input placeholder="请输入车牌号" style={{ width: 200, marginRight: 10 }} value={carNo} onPressEnter={clickSearch} onChange={(e) => setCarNo(e.target.value)}></Input>
                <Input placeholder="请输入驾驶员" style={{ width: 200, marginRight: 10 }} value={driver} onPressEnter={clickSearch} onChange={(e) => setDriver(e.target.value)}></Input>
                <Button type="primary" style={{ marginRight: 10 }} onClick={clickSearch}><span className='iconfont icon-sousuo buttonIcon'></span>搜索</Button>
                <Button type="primary" style={{ marginRight: 10 }} className='buttonReset' onClick={clickReset}><span style={{fontSize: 13}} className='iconfont icon-zhongzhi buttonIcon'></span>重置</Button>
            </div>
            <div className="bottom">
                <DeTable columns={tableColunm} total={tableTotal}
                         setOn={setPageNo}
                         setSize={setPageSize}
                         current={pageNo}
                         pageSize={pageSize}
                         onPaginationChange={(pageNo, pageSize) => onPaginationChange(pageNo, pageSize)}
                         dataSource={tableData} />
            </div>
            <Modal
                title={modalType === 'add' ? '新增车辆' : '编辑'}
                visible={editVisible}
                onCancel={cancelEdit}
                maskClosable={false}
                destroyOnClose={true}
                centered={true}
                width={'50%'}
                className='editClass'
                footer={
                    <div style={{ width: '100%', textAlign: 'center' }}>
                        <Button type="primary" style={{ width: 200 }} loading={confirmLoading} onClick={editConfire}>提交</Button>
                    </div>
                }
            >
                {
                    modalType === 'add' ?
                    <Form style={{display: 'inline-block'}}>
                        <Form.Item>
                            <span></span>
                        </Form.Item>
                        <Col span={12}>
                            <Form.Item {...formItemLayout} label="车牌号：">
                                {getFieldDecorator('carNo', {
                                    rules: [{ required: true, message: '请输入车牌号！',pattern:new RegExp(/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4,5}[A-Z0-9挂学警港澳]{1}$/, "g") }],
                                })(
                                    <Input
                                        placeholder="请输入车牌号"
                                    />,
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item {...formItemLayout} label="车辆类型：">
                            {getFieldDecorator('carType', {
                                rules: [{ required: true, message: '请选择车辆类型!' }],
                            })(
                                <Select >
                                    {
                                        carTypeData.map((item,index) => {
                                        return (
                                        <Option value={item.dictValue} key={item.dictValue} >{item.dictDesc}</Option>
                                        )
                                        })
                                    }
                                </Select>
                            )}

                            </Form.Item>
                        </Col>
                         <Col span={12}>
                            <Form.Item {...formItemLayout} label="驾驶人：">
                                {getFieldDecorator('driver', {
                                    rules: [{ required: true, message: '请输入驾驶人！' }],
                                })(
                                    <Input
                                        placeholder="请输入驾驶人"
                                    />,
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item {...formItemLayout} label="手机号：">
                                {getFieldDecorator('phone', {
                                    rules: [{ required: true, message: '请输入手机号！',pattern:new RegExp(/^1[3456789]\d{9}$/, "g") }],
                                })(
                                    <Input
                                        placeholder="请输入手机号"
                                    />,
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
							<Form.Item {...formItemLayout} label="所属猪场：">
								{getFieldDecorator('pigFramId', {
									rules: [{ required: true, message: '请选择所属猪场!' }],
								})(
									<Select mode="multiple" onChange={selectPigFram}>
										{
							  				childRegionData.map((item,index) => {
								  				return (
                                                    <Option value={item.pigFramId} key={item.pigFramId}>{item.pigFramName}</Option>
								  				)
							  				})
										}
									</Select>
								)}

							</Form.Item>
						</Col>
                        <Col span={12}>
                            <Form.Item {...formItemLayout} label="所属洗消点：">
                                {getFieldDecorator('washSpotIds', {
                                    rules: [{ required: true, message: '请选择所属洗消点!' }],
                                })(
                                    <Select mode="multiple">
                                        {
                                            washSpotList.map((item,index) => {
                                                return (
                                                    <Option value={item.id} key={item.id} >{item.name}</Option>
                                                )
                                            })
                                        }
                                    </Select>
                                )}

                            </Form.Item>
                        </Col>
                    </Form>
                    :
                    <Form style={{ display: 'inline-block' }}>
                        <Form.Item>
                            {getFieldDecorator('id')(
                                <span></span>
                            )}
                        </Form.Item>
                        <Col span={12}>
                            <Form.Item {...formItemLayout} label="车牌号：">
                                {getFieldDecorator('carNo', {
                                    rules: [{ required: true, message: '请输入车牌号！',pattern:new RegExp(/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4,5}[A-Z0-9挂学警港澳]{1}$/, "g") }],
                                })(
                                    <Input
                                        placeholder="请输入车牌号"
                                    />,
                                )}
                            </Form.Item>
                        </Col>
                       <Col span={12}>
							<Form.Item {...formItemLayout} label="车辆类型：">
								{getFieldDecorator('carType', {
									rules: [{ required: true, message: '请选择车辆类型!' }],
								})(
									<Select >
										{
							  				carTypeData.map((item,index) => {
								  				return (
								  					<Option value={item.dictValue} key={item.dictValue} >{item.dictDesc}</Option>
								  				)
							  				})
										}
									</Select>
								)}

							</Form.Item>
						</Col>
                        <Col span={12}>
                            <Form.Item {...formItemLayout} label="驾驶人：">
                                {getFieldDecorator('driver', {
                                    rules: [{ required: true, message: '请输入驾驶人！' }],
                                })(
                                    <Input
                                        placeholder="请输入驾驶人"
                                    />,
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item {...formItemLayout} label="手机号：">
                                {getFieldDecorator('phone', {
                                    rules: [{ required: true, message: '请输入手机号！',pattern:new RegExp(/^1[3456789]\d{9}$/, "g") }],
                                })(
                                    <Input
                                        placeholder="请输入手机号"
                                    />,
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
							<Form.Item {...formItemLayout} label="所属猪场：">
								{getFieldDecorator('pigFramId', {
									rules: [{ required: true, message: '请选择所属猪场!' }],
								})(
									<Select mode="multiple" onChange={selectPigFram}>
										{
							  				childRegionData.map((item,index) => {
								  				return (
                                                    <Option value={item.pigFramId} key={item.pigFramId}>{item.pigFramName}</Option>
								  				)
							  				})
										}
									</Select>
								)}

							</Form.Item>
						</Col>
                        <Col span={12}>
							<Form.Item {...formItemLayout} label="所属洗消点：">
								{getFieldDecorator('washSpotIds', {
									rules: [{ required: true, message: '请选择所属洗消点!' }],
								})(
									<Select mode="multiple">
										{
                                            washSpotList.map((item,index) => {
								  				return (
								  					<Option value={item.id} key={item.id} >{item.name}</Option>
								  				)
							  				})
										}
									</Select>
								)}

							</Form.Item>
						</Col>
                    </Form>
                }
            </Modal>
        </Container>

    )
}

export default Form.create()(CarInfo)
